import { render } from "./alunoArquivo.vue?vue&type=template&id=786b528b"
import script from "./alunoArquivo.vue?vue&type=script&lang=js"
export * from "./alunoArquivo.vue?vue&type=script&lang=js"

import "./alunoArquivo.vue?vue&type=style&index=0&id=786b528b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__